/* ============================================================
   SCANDALOUS — "Midnight Cinema" behaviour layer
   Scroll reveals, cursor spotlight, intro curtain, marquee.
   Fails gracefully: if anything throws, content stays visible.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var inEditor = window.Shopify && window.Shopify.designMode;

  /* ---- Scroll reveal --------------------------------------- */
  function setupReveal() {
    if (reduceMotion) return;
    document.documentElement.classList.add('cine-ready');

    var targets = document.querySelectorAll(
      '.shopify-section .banner, ' +
      '.shopify-section .slideshow, ' +
      '.shopify-section .collection, ' +
      '.shopify-section .featured-collection, ' +
      '.shopify-section .image-with-text, ' +
      '.shopify-section .rich-text, ' +
      '.shopify-section .multicolumn, ' +
      '.card-wrapper, ' +
      '.title-wrapper, ' +
      '.product__info-container > *'
    );

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('cine-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cine-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    var i = 0;
    targets.forEach(function (el) {
      // Skip anything already above the fold so it doesn't flash hidden.
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.9) {
        el.classList.add('cine-reveal', 'cine-in');
        return;
      }
      el.classList.add('cine-reveal');
      // Gentle stagger within sibling groups.
      el.style.transitionDelay = (Math.min(i % 4, 3) * 90) + 'ms';
      io.observe(el);
      i++;
    });
  }

  /* ---- Crossfade slideshows (no controls, smooth fade) ----- */
  function startCrossfade(section) {
    var slides = Array.from(section.querySelectorAll('.slideshow__slide'));
    if (slides.length < 2) return;
    var current = 0;
    // Mark section ready so CSS stops showing :first-child fallback
    section.classList.add('cine-cf-ready');
    slides[current].classList.add('cine-fade-active');
    setInterval(function () {
      slides[current].classList.remove('cine-fade-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('cine-fade-active');
    }, 4500);
  }

  function setupHeroCrossfade() {
    if (reduceMotion) return;
    // Small delay so Dawn's slideshow component initialises first
    setTimeout(function () {
      var ids = ['slideshow_hUNdRx', 'slideshow_G7kHPd'];
      ids.forEach(function (id) {
        // Section IDs include a template prefix, so match by suffix
        var section = document.querySelector('[id$="__' + id + '"]');
        if (section) startCrossfade(section);
      });
    }, 300);
  }

  /* ---- Scroll header glassmorphism ------------------------ */
  function setupScrollHeader() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    function tick() {
      header.classList.toggle('cine-scrolled', window.scrollY > 48);
    }
    window.addEventListener('scroll', tick, { passive: true });
    tick();
  }

  /* ---- Cursor spotlight ------------------------------------ */
  function setupSpotlight() {
    if (reduceMotion || !finePointer) return;
    var el = document.querySelector('.cine-spotlight');
    if (!el) return;
    var x = window.innerWidth / 2, y = window.innerHeight / 2;
    var tx = x, ty = y, raf = null;

    function loop() {
      x += (tx - x) * 0.18;
      y += (ty - y) * 0.18;
      el.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      raf = Math.abs(tx - x) > 0.5 || Math.abs(ty - y) > 0.5
        ? requestAnimationFrame(loop) : null;
    }
    window.addEventListener('mousemove', function (e) {
      tx = e.clientX; ty = e.clientY;
      el.style.opacity = '1';
      if (!raf) raf = requestAnimationFrame(loop);
    }, { passive: true });
    document.addEventListener('mouseleave', function () { el.style.opacity = '0'; });
  }

  /* ---- Intro curtain (once per session) -------------------- */
  function setupIntro() {
    var intro = document.querySelector('.cine-intro');
    if (!intro) return;
    if (reduceMotion || inEditor || sessionStorage.getItem('cineIntroShown')) {
      intro.parentNode && intro.parentNode.removeChild(intro);
      return;
    }
    sessionStorage.setItem('cineIntroShown', '1');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      intro.classList.add('is-leaving');
      document.body.style.overflow = '';
    }, 1700);
    setTimeout(function () {
      intro.parentNode && intro.parentNode.removeChild(intro);
    }, 2700);
  }

  /* ---- Footer accordion (mobile nav blocks) ---------------- */
  function setupFooterAccordion() {
    if (window.innerWidth > 749) return;
    var menuBlocks = document.querySelectorAll('.footer .footer-block--menu');
    menuBlocks.forEach(function (block) {
      var heading = block.querySelector('.footer-block__heading');
      if (!heading) return;
      heading.addEventListener('click', function () {
        block.classList.toggle('cine-footer-open');
      });
    });
  }

  function init() {
    try { setupIntro(); } catch (e) {}
    try { setupReveal(); } catch (e) {}
    try { setupSpotlight(); } catch (e) {}
    try { setupScrollHeader(); } catch (e) {}
    try { setupHeroCrossfade(); } catch (e) {}
    try { setupFooterAccordion(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run reveal wiring when sections are re-rendered in the theme editor.
  if (inEditor) {
    document.addEventListener('shopify:section:load', function () {
      try { setupReveal(); } catch (e) {}
    });
  }
})();
